const state = {
  titulo_base: 'Vlive Media - ',
  titulo: 'Vlive Media - Inicio',
  snack_mostrando: 0,
  snack_texto: 'Prueba',
  snack_tiempo: 0
}

const mutations = {
  CAMBIAR_TITULO: (state, titulo) => {
    state.titulo = 'Vlive Media - ' + titulo
  },
  MOSTRAR_SNACK: (state, opts) => {
    if(opts.texto && opts.texto.length) {
      state.snack_texto = opts.texto
      state.snack_mostrando = 1
    }
  },
  OCULTAR_SNACK: (state) => {
    setTimeout(function() {
      state.snack_mostrando = 0
    }, 500)
  }
}

const actions = {
  cambiarTitulo: (context, titulo) => {
    context.commit('CAMBIAR_TITULO', titulo);
  },
  mostrarSnack: (context, opts) => {
    context.commit('MOSTRAR_SNACK', opts)
  },
  ocultarSnack: (context) => {
    context.commit('OCULTAR_SNACK')
  }
}

export default {
  state,
  mutations,
  actions
}